module.exports = __webpack_public_path__ + "img/n3.2e66067e.png";